<template>
  <div style="width:100%;">

    <div>
      <b-dropdown :text="text" variant="light" style="width:100%">
        <b-dropdown-item-button v-for="(option,index) in options" :key="index" @click="boundVariable=option; fbRef.set(boundVariable.trim());">
          {{option}}
        </b-dropdown-item-button>
        <b-dropdown-divider></b-dropdown-divider>
        <b-dropdown-item diabled>Or type into box</b-dropdown-item>
      </b-dropdown>
    </div>

    <b-input-group prepend="when you" append=".">
      <b-form-input type="text" v-model="boundVariable" @change="fbRef.set(boundVariable.trim());" placeholder="e.g. walk to your local post office">
      </b-form-input>
    </b-input-group>

    <b-alert show variant="danger" class="mt-2" v-if="boundVariable && boundVariable.charAt(0).toLowerCase() !== boundVariable.charAt(0)">Please don't capitalise as it messes up questions later shown to the participant.</b-alert>
    <b-alert show variant="danger" class="mt-2" v-if="boundVariable && boundVariable.charAt(boundVariable.length-1)==='.'">Please don't end with a full stop because it messes up grammar of later questions shown to the pariticipant.</b-alert>

    <br>
  </div>

</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: "Choose"
    },
    fbRef: {
      // For writing
      type: Object,
      required: true
    }
  },
  data: () => ({
    boundVariable: "",

    options: [
      "walk indoors on level ground",
      "walk outdoors on level ground",
      "walk up a hill without stopping",
      "walk up one flight of stairs without stopping",
      "walk up 2 flights of stairs without stopping",
      "do gardening",
      "do light housework",
      "run or jog",
      "lift or move heavy objects",
      "cycle",
      "play football",
      "walk briskly for 10 minutes",
      "have a stressful situation"
    ]
  }),
  created() {
    this.fbRef.on("value", snapshot => {
      this.boundVariable = snapshot.val();
    });
  },
  beforeDestroy() {
    this.fbRef.off("value");
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ResViewAnginaTrigger.vue